import React from "react"

import Terms from "../components/Terms/terms"
import Layout from "../components/layout"

export default () => (
  <Layout>
    <Terms />
  </Layout>
)
